module.exports = __webpack_public_path__ + "img/bmbf-beauftragte-logo.6ef8f4f9.png";